import { render, staticRenderFns } from "./MainColumnEdit.vue?vue&type=template&id=62bebc39&scoped=true&"
import script from "./MainColumnEdit.vue?vue&type=script&lang=js&"
export * from "./MainColumnEdit.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "62bebc39",
  null
  
)

export default component.exports